import { useState, useEffect } from "react";

/**
 * Custom hook for debouncing a value.
 * @param value - The value to debounce.
 * @param delay - The debounce delay in milliseconds (default 500ms).
 * @returns The debounced value.
 */
function useDebounce<T>(value: T, delay: number = 500): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Cleanup the timeout on value or delay change, or component unmount
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

export default useDebounce;
